import { signal, WritableSignal } from "@angular/core";
import { AppAvailability } from "@app/core";

export class AppManagementModel {
  apps: WritableSignal<AppAvailability>;

  constructor() {
    this.apps = signal<AppAvailability>(undefined);
  }
}
